import { comments } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              瓜友热评
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              百万瓜友真实评论，听听大家都在讨论什么
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {comments.map((comment) => (
              <div
                key={comment.name}
                className="bg-background-100 rounded-xl p-4 md:p-5"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 font-heading text-sm">
                    {comment.name.charAt(0)}
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-800">
                      {comment.name}
                    </div>
                    <div className="text-xs text-foreground-500">{comment.time}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}